export default {
  categories: {
    shoes: 'Buty',
    hoodies: 'Bluzy / Swetry',
    tShirts: 'Koszulki',
    jackets: 'Kurtki',
    pants: 'Spodnie / Szorty',
    headwear: 'Nakrycia głowy',
    sets: 'Zestawy',
    underwear: 'Bielizna / Majtki',
    jersey: 'Koszulka sportowa',
    accessories: 'Akcesoria',
    bags: 'Torby',
    belts: 'Paski',
    perfumes: 'Perfumy',
    other: 'Inne rzeczy',
  },
};